/* eslint-disable import/extensions */
import {
  Input,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import {
  MdFilterList,
  MdLockOpen,
  MdLockOutline,
  MdSearch,
} from 'react-icons/md';
import { AdminDetails } from '../AdminDetails';

import { data } from '../mock.js';
import {
  CellHeaderStyled,
  CellStyled,
  DivBlockStyled,
  DivSearchStyled,
} from './index.styles.js';

export function ManagementTable() {
  const [seeDetails, setSeeDetails] = useState(false);
  return (
    <div>
      {!seeDetails ? (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ color: '#fff' }}>
              <Typography variant="h3">Administradores</Typography>
              <div style={{ display: 'flex', gap: 32, margin: '24px 0' }}>
                <DivBlockStyled>
                  <MdLockOutline size={20} color="lightgray" />
                </DivBlockStyled>
                <DivBlockStyled>
                  <MdLockOpen size={20} color="lightgray" />
                </DivBlockStyled>
              </div>
            </div>
            <DivSearchStyled>
              <Input
                placeholder=" Pesquisar administrador"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MdSearch color="lightgray" />
                    </InputAdornment>
                  ),
                }}
              />
              <MdFilterList color="lightgray" size={22} />
            </DivSearchStyled>
          </div>
          <TableContainer component={Paper}>
            <Table size="small">
              <CellHeaderStyled>
                <TableRow>
                  <TableCell />
                  <TableCell>Nome</TableCell>
                  <TableCell>E-mail</TableCell>
                  <TableCell>Plano</TableCell>
                  <TableCell>Data de assinatura</TableCell>
                  <TableCell>Último pagamento</TableCell>
                  <TableCell>Obras iniciadas</TableCell>
                  <TableCell>Espaço utilizado</TableCell>
                </TableRow>
              </CellHeaderStyled>
              <TableBody>
                {data.map((clients) => (
                  <CellStyled
                    key={clients.id}
                    onClick={() => setSeeDetails(!seeDetails)}
                  >
                    <TableCell>
                      <input type="checkbox" className="check" />
                    </TableCell>
                    <TableCell>{clients.name}</TableCell>
                    <TableCell>{clients.email}</TableCell>
                    <TableCell>{clients.plan}</TableCell>
                    <TableCell className="date">
                      {new Intl.DateTimeFormat('pt-BR').format(
                        new Date(clients.signature_date)
                      )}
                    </TableCell>
                    <TableCell className="date1">
                      {new Intl.DateTimeFormat('pt-BR').format(
                        new Date(clients.last_payment)
                      )}
                    </TableCell>
                    <TableCell className="date">
                      {clients.works_started}
                    </TableCell>
                    <TableCell className="date">
                      {clients.used_space}/{clients.total_space} GB
                    </TableCell>
                  </CellStyled>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <>
          <Typography
            variant="h6"
            color="primary"
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => setSeeDetails(!seeDetails)}
          >
            Voltar para administradores
          </Typography>
          <AdminDetails />
        </>
      )}
    </div>
  );
}
